import { useState, useCallback } from 'react'
import { NotificationType } from '@/components/Notifications/NotificationToast'

export interface Notification {
  id: string
  message: string
  type: NotificationType
}

export function useNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>([])

  const addNotification = useCallback((message: string, type: NotificationType = 'info') => {
    const id = Date.now().toString()
    setNotifications(prev => [...prev, { id, message, type }])
  }, [])

  const removeNotification = useCallback((id: string) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }, [])

  const showSuccess = useCallback((message: string) => {
    addNotification(message, 'success')
  }, [addNotification])

  const showError = useCallback((message: string) => {
    addNotification(message, 'error')
  }, [addNotification])

  const showWarning = useCallback((message: string) => {
    addNotification(message, 'warning')
  }, [addNotification])

  const showInfo = useCallback((message: string) => {
    addNotification(message, 'info')
  }, [addNotification])

  return {
    notifications,
    addNotification,
    removeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}